import { useState } from "react";

import { Divider } from "@/components/ui/Divider";
import { config } from "@/config";
import { LoginError } from "@/pages/LoginPage/LoginError";
import { LoginForm } from "@/pages/LoginPage/LoginForm";
import styles from "@/pages/LoginPage/LoginPage.module.css";
import { LoginPageLogo } from "@/pages/LoginPage/LoginPageLogo";
import { LoginPageTitle } from "@/pages/LoginPage/LoginPageTitle";
import { MicrosoftLoginButton } from "@/pages/LoginPage/MicrosoftLoginButton";
import { FormValues, LoginErrorType } from "@/pages/LoginPage/login-page.types";
import { AuthError } from "@/services/auth/auth.errors";
import { login } from "@/services/auth/auth.service";
import { useAppDispatch } from "@/store";
import { authenticate } from "@/store/slices/auth.slice";

const LoginPage = () => {
    const [error, setError] = useState<LoginErrorType | null>(null);
    const dispatch = useAppDispatch();

    const handleLogin = async (data: FormValues) => {
        setError(null);

        try {
            const res = await login(data);
            dispatch(authenticate({ authStrategy: "adfs", authData: res }));
        } catch (err) {
            if (err instanceof AuthError) {
                if (err.data?.error_description === "Your user name or password is invalid.") {
                    setError("invalidLogin");
                } else if (err.data?.error_description === "Too many login attempts. Please try again later.") {
                    setError("tooManyLoginAttempts");
                } else if (err.data?.error_description === "Your password has expired.") {
                    setError("expiredPassword");
                } else {
                    setError("serverError");
                }
            } else {
                setError("serverError");
            }
        }
    };

    return (
        <div>
            <div className={styles.image} />
            <div className={styles.panel}>
                <div className={styles.panel_content}>
                    <LoginPageLogo />
                    <LoginPageTitle />
                    <div className={styles.login_method_list}>
                        {error && <LoginError type={error} />}

                        <div>
                            <LoginForm onSubmit={handleLogin} />
                        </div>

                        {config.AZURE_AUTH_ENABLED && (
                            <>
                                <div className={styles.login_method_divider}>
                                    <Divider className={styles.login_method_divider_hr} />
                                    <span className={styles.login_method_divider_text}>or login with</span>
                                    <Divider className={styles.login_method_divider_hr} />
                                </div>

                                <div>
                                    <MicrosoftLoginButton />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export { LoginPage };
